// @flow

import React, { Component } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Ionicon from "react-ionicons";
import styled from "styled-components";

import { colors } from "./styles.js";

const formatter = new window.Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
const valueToCurrency = (value: number) =>
  formatter.format(value).replace("$", "");

type InputProps = {
  id: string,
  label: string,
  helpText: string | React.Element<*>,
  onUpdate: (string, number) => void,
  values: { [string]: number }
};

export default class InputField extends Component {
  props: InputProps;

  state: {
    unsanitizedInput: string,
    helpOpen: boolean,
    helpHovered: boolean
  };

  constructor(props: InputProps) {
    super(props);
    this.state = {
      unsanitizedInput: valueToCurrency(props.values[props.id]),
      helpHovered: false,
      helpOpen: false
    };
  }

  componentWillReceiveProps(newProps: InputProps) {
    this.setState({
      unsanitizedInput: valueToCurrency(newProps.values[newProps.id])
    });
  }

  _handleFocus = (e: any) => e.target.select();
  _handleChange = (e: any) =>
    this.setState({ unsanitizedInput: e.target.value });
  _checkForEnter = (e: any) => e.keyCode === 13 && e.target.blur();

  _saveValue = () => {
    const sanitizedInput =
      parseFloat(this.state.unsanitizedInput.replace(",", "")) || 0;
    this.setState({ unsanitizedInput: sanitizedInput.toString() });
    this.props.onUpdate(this.props.id, sanitizedInput);
  };

  hoverHelp = () => this.setState({ helpHovered: true });
  unHoverHelp = () => this.setState({ helpHovered: false });
  toggleHelp = () =>
    this.setState(oldState => ({
      helpOpen: !oldState.helpOpen
    }));

  render() {
    return (
      <StyledInput>
        <div className="field-label">
          <div>{this.props.label}</div>
          <div
            className="help-icon-wrapper"
            onMouseEnter={this.hoverHelp}
            onMouseLeave={this.unHoverHelp}
            onClick={this.toggleHelp}
          >
            <Ionicon
              className="help-icon"
              icon="ion-help-circled"
              fontSize="1em"
              color={
                this.state.helpOpen || this.state.helpHovered
                  ? "#4F8EF7"
                  : "grey"
              }
            />
          </div>
        </div>
        <div className="input-wrapper">
          <span className="dollar">$</span>
          <input
            className="field-input"
            value={this.state.unsanitizedInput}
            onChange={this._handleChange}
            onBlur={this._saveValue}
            onFocus={this._handleFocus}
            onKeyDown={this._checkForEnter}
          />
        </div>
        <ReactCSSTransitionGroup
          transitionName="help-text"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {this.state.helpOpen &&
            <div key="help-text" className="help-text">
              {this.props.helpText}
            </div>}
        </ReactCSSTransitionGroup>
      </StyledInput>
    );
  }
}

const StyledInput = styled.div`
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;

  .field-label {
    display: flex;
    align-items: center;
    font-size: 1em;
    font-weight: 400;
    margin-bottom: 5px;
    color: #333;

    .help-icon-wrapper {
      padding: 3px;
      padding-left: 10px;
      cursor: pointer;
      display: flex;
    }
  }

  .input-wrapper {
    font-size: 1.5em;
    border-bottom: 1px solid #ccc;
    padding: 3px;
    display: flex;
    align-items: center;

    .dollar { color: ${colors.green}; }

    .field-input {
      flex: 1;
      margin-left: 10px;
      padding-left: 10px;
      border: none;

      &:focus {
        outline: 0;
      }
    }
  }

  .help-text {
    margin-top: 10px;
    color: #4F8EF7;
  }
  .help-text-enter { opacity: 0.01; }
  .help-text-enter.help-text-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }
  .help-text-leave { opacity: 1; }
  .help-text-leave.help-text-leave-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
`;



// WEBPACK FOOTER //
// ./src/InputField.js